<template>
  <div>
    <Form ref="editModel" :model="editModel" :rules="ruleValidate" :label-width="100" inline>
      <FormItem label="组织名称" prop="organizationName">
        <Input class="w-250" v-model="editModel.organizationName"></Input>
      </FormItem>
    </Form>
    <div class="text-center">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')">确 定</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      editModel: {
        id: "",
        organizationName: "",
        updateUser: "",
      },
      ruleValidate: {
        organizationName: [
          {
            required: true,
            message: "组织名称不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    this.editModel = this.currentData;
    this.editModel.updateUser = this.$store.state.name;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api
            .post(`organization/update?organizationName=${this.editModel.organizationName}&id=${this.editModel.id}&updateUser=${this.editModel.updateUser}`)
            .then((rsp) => {
              if (rsp != false) {
                this.$Message.success("更新成功");
                this.returnBack();
                this.$emit("loadData");
              }
            });
        }
      });
    },
  },
};
</script>
<style scoped>
</style>